// "Últimos colores usados" — persistidos en localStorage por dispositivo (mismo
// patrón que ultimosTextos). Solo hex de 6 dígitos; transparent no se guarda.

const KEY = 'atlas_edicion_grafica_colores';
const MAX = 10;

const isHex6 = (c: unknown): c is string =>
  typeof c === 'string' && /^#[0-9a-fA-F]{6}$/.test(c);

export function getUltimosColores(): string[] {
  try {
    const raw = localStorage.getItem(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr.filter(isHex6).map((c) => c.toLowerCase()) : [];
  } catch {
    return [];
  }
}

export function addUltimoColor(hex: string): void {
  if (!isHex6(hex)) return;
  const c = hex.toLowerCase();
  try {
    const cur = getUltimosColores().filter((x) => x !== c);
    cur.unshift(c);
    localStorage.setItem(KEY, JSON.stringify(cur.slice(0, MAX)));
  } catch {
    /* localStorage bloqueado → no persiste, no rompe */
  }
}
